// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1ijAr","unreadBadge":"styles_unreadBadge__3Hc5E","modalContent":"styles_modalContent__7_pB0","modal":"styles_modal__1VXuW"};